export default __webpack_public_path__ + "static/media/attachFile.b8354217.svg";